import * as React from 'react';

import classNames from 'classnames';

import {colors} from '../colors/colors';
import {StarIcon} from '../icon';

import styles from './primary-icon-wrapper.module.css';

type Props = {
    isHidden?: boolean;
    children: React.ReactNode;
};

export function PrimaryIconWrapper(props: Props) {
    return (
        <div
            className={classNames(styles.wrapper, {
                [styles['wrapper--hidden']]: props.isHidden,
            })}
        >
            <StarIcon size={16} style={{color: colors.orange}} className={styles.icon} />
            {props.children}
        </div>
    );
}
